<template>
  <div class="content revdetail" style="min-height: calc(100vh - 62px);">
    <h2 class="m-n">売上明細</h2>
    <div class="row hpanel">
      <a href="/affiliate/reward-info">報酬明細</a>
      &nbsp;
      <a href="/promotion/promotion-info">広告費明細</a>
      <br>
      <br>
      <base-table
        :url="'Sale/detail'"
        :method="'post'"
        :columns="$options.salesColumns"
        :isSearchable="true"
        :isSearchMultiple="true"
        :malls="malls"
        :paginationStorageKey="'revdetail'"
        @keyword="onHandleSearch"
      >
        <template slot="orderDate" slot-scope="props">
          <span>{{ formatDate(props.rowData.orderDate) }}</span>
        </template>
        <template slot="itemImageUrl" slot-scope="props">
          <img :src="prepareImgSrc(props.rowData.itemImageUrl)" class="product-img"/>
        </template>
        <template slot="detail" slot-scope="props">
          <p v-html="replaceHTMLSellerInfo(props.rowData.detail)"></p>
        </template>
        <template slot="orderQuantity" slot-scope="props">
          <span v-bind:class="{ 'text-red': isMinus(props.rowData.orderQuantity) }">{{ props.rowData.orderQuantity }}</span>
        </template>
        <template slot="orderUnitPrice" slot-scope="props">
          <span v-bind:class="{ 'text-red': isMinus(props.rowData.orderUnitPrice) }">{{ formatAmount(props.rowData.orderUnitPrice) }}</span>
        </template>
        <template slot="taxRate" slot-scope="props">
          <p v-html="`${props.rowData.taxRate}%`"></p>
        </template>
        <template slot="totalAmount" slot-scope="props">
          <span v-bind:class="{ 'text-red': isMinus(props.rowData.totalAmount) }">{{ formatAmount(props.rowData.totalAmount) }}</span>
        </template>
        <template slot="mallCode" slot-scope="props">
          <img :src="prepareImgSrc(props.rowData.mall)"/>
        </template>
      </base-table>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import BaseTable from '@/components/BaseTableAPI'
import MallService from '@/services/mallservice'
import Util, {replaceHTMLSellerInfo} from '@/common/utility'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  components: {
    BaseTable
  },
  data () {
    return {
      malls: [
        {
          mallCode: null,
          mallName: 'すべて'
        }
      ]
    }
  },
  salesColumns: [
    {
      title: '日付',
      name: 'orderDate',
      customCell: true,
      cellClass: 'text-center',
      headerClass: 'col-sm-2 w-100'
    },
    {
      title: '画像',
      name: 'itemImageUrl',
      customCell: true,
      sortable: false,
      cellClass: 'text-center',
      headerClass: 'col-sm-2 w-100'
    },
    {
      title: '明細',
      name: 'detail',
      customCell: true,
      cellClass: 'text-left',
      headerClass: 'col-sm-9 product-name'
    },
    {
      title: '個数',
      name: 'orderQuantity',
      customCell: true,
      cellClass: 'text-right',
      headerClass: 'col-sm-2'
    },
    {
      title: '単価(税込)',
      name: 'orderUnitPrice',
      customCell: true,
      cellClass: 'text-right',
      headerClass: 'col-sm-2 w-100'
    },
    {
      title: '税率',
      name: 'taxRate',
      customCell: true,
      cellClass: 'text-right',
      headerClass: 'col-sm-2 w-100'
    },
    {
      title: '合計(税込)',
      name: 'totalAmount',
      customCell: true,
      cellClass: 'text-right',
      headerClass: 'col-sm-2'
    },
    {
      title: 'モール',
      name: 'mallCode',
      customCell: true,
      cellClass: 'text-center',
      headerClass: 'col-sm-3 w-150'
    }
  ],
  created () {
    this.getAllMall()
  },
  mounted () {
    let logParams = {
      name: eventCode.detail_revenue.show,
      properties: {}
    }
    EventService.postTrackLog(logParams)
  },
  methods: {
    replaceHTMLSellerInfo,
    isMinus (value) {
      return value < 0
    },
    /*
     * Format money
     *
     * @param {Int} value Value to be transformed
     *
     * @return {String}
     */
    formatAmount (value) {
      return `¥${Util.formatMoney(value)}`
    },
    /*
     * Format date
     *
     * @param {String} value Value to be transformed
     *
     * @return {String}
     */
    formatDate (value) {
      return value ? moment(value).format('YYYY/MM/DD HH:mm') : null
    },
    /*
     * Return img source from DB or noimg url
     *
     * @param {String} value Img src
     *
     * @return {String}
     */
    prepareImgSrc (value) {
      return value || `${process.env.NODE_DOMAIN}/static/dists/img/noimg.png`
    },
    /*
     * Call API to get all malls
     *
     * @return void
     */
    getAllMall () {
      MallService.getAll()
        .then((response) => {
          this.malls = [
            ...this.malls,
            ...response.malls
          ]
        })
        .catch((err) => {
          this.$store.commit('toggleModal', {
            show: true,
            message: err
          })
        })
    },
    onHandleSearch (keyword) {
      let mall = 'すべて'
      if (keyword.mallCode && keyword.mallCode.length) {
        mall = this.malls.filter(item => item.mallCode === keyword.mallCode[0])[0]
      }
      let logParams = {
        name: eventCode.detail_revenue.click_filter_button,
        properties: {
          keyword: {
            detail: keyword.detail,
            startOfferDate: keyword.startOfferDate,
            endOfferDate: keyword.endOfferDate,
            mall: mall
          }
        }
      }
      EventService.postTrackLog(logParams)
    }
  }
}
</script>

<style scoped>
.revdetail /deep/ .box-base-table-search {
  display: block !important;
  justify-content: unset;
  align-items: unset;
  flex-wrap: unset;
}
.revdetail /deep/ .box-base-table-search .search-multiple {
  flex-grow: unset;
  margin-right: unset;
  display: flex;
  align-items: center;
}
.revdetail /deep/ .box-base-table-search .search-multiple input {
  margin-right: 30px;
}
@media (max-width: 1024px) {
  /* .hpanel /deep/ .flexbox {
    display: table !important;
  } */
  .hpanel /deep/ .sale-detail-search {
    display: inline;
  }
  .hpanel /deep/ .datepicker-end {
    margin-left: 50px;
  }
  .hpanel /deep/ .search-block-detail {
    margin-top: 10px;
    width: 287px;
  }
  .hpanel /deep/ .search-block-detail>label {
    width: 92px;
  }
  .hpanel /deep/ .search-block-mall {
    margin-left: 50px;
    width: 264px;
  }
  /* .hpanel /deep/ .btn-warning {
    margin-top: 10px;
    margin-left: 76px;
  } */
  .revdetail /deep/ .box-base-table-search .sale-detail-search .box-detail-btn-search {
    margin-left: 75px;
    margin-top: 10px;
  }
}
@media (max-width: 425px) {
  .hpanel /deep/ .datepicker-end {
    margin-top: 10px;
    margin-left: 21px;
  }
  .hpanel /deep/ .search-block-detail {
    margin-top: 10px;
    margin-left: 38px;
    width: 250px;
  }
  .hpanel /deep/ .search-block-detail>label {
    width: 30px;
  }
  .hpanel /deep/ .search-block-mall {
    margin-top: 10px;
    margin-left: 24px;
    width: 264px;
  }
  .hpanel /deep/ .table-wrapper {
    overflow-x: auto !important;
  }
  .hpanel /deep/ .table-wrapper .table {
    min-width: 700px !important;
    max-width: none !important;
  }
  .revdetail /deep/ .box-base-table-search .sale-detail-search .datepicker-start label {
    margin-right: 14px;
  }
  .revdetail /deep/ .box-base-table-search .sale-detail-search .box-detail-btn-search {
    margin-left: 77px;
  }
}
@media (max-width: 768px) {
  .content {
    padding: 10px !important;
  }
}
@media (max-width: 992px) {
  /deep/ .table-wrapper {
    overflow-x: auto;
  }
  /deep/ .table {
    width: auto;
    min-width: max-content;
  }
  /deep/ .table thead tr .product-name {
    width: 220px;
  }
}
@media (min-width: 1200px) {
  .revdetail /deep/ .box-base-table-search .sale-detail-search {
    margin-right: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/revdetail/Revdetail.vue